export const EncounterStatusEnum = {
    STARTED: "STARTED",
    FINALIZED: "FINALIZED",
    INVALIDATED: "INVALIDATED",
};

const labels = {
    [EncounterStatusEnum.STARTED]: "Em andamento",
    [EncounterStatusEnum.FINALIZED]: "Finalizada",
    [EncounterStatusEnum.INVALIDATED]: "Inválida",
};

export const ENCOUNTER_STATUS_OPTIONS = [
    {value: EncounterStatusEnum.FINALIZED, label: labels[EncounterStatusEnum.FINALIZED]},
    {value: EncounterStatusEnum.INVALIDATED, label: labels[EncounterStatusEnum.INVALIDATED]},
    {value: EncounterStatusEnum.STARTED, label: labels[EncounterStatusEnum.STARTED]},
];

export const encounterStatusLabel = (status) => labels[status] ?? "";

export const isEncounterInvalidated = (status) => status === EncounterStatusEnum.INVALIDATED;
